import { ActionIcon, Alert, Anchor, Badge, Box, Card, Center, Divider, Group, Modal, ScrollArea, Skeleton, Stack, Text, Title, Tooltip } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import { IconArrowUpRight } from '@tabler/icons-react';
import { logger } from 'utils/logger';
import { createStyles } from '@mantine/core'; // ✅ v5: from @mantine/core, not @mantine/emotion
import { getStyleGlobalSearch } from 'services/styleService';
import { useDispatch } from 'react-redux';
import { setGlobalSearch } from 'app/appSlice';
import { closeAllModals } from '@mantine/modals';
import { AppConstants, CompanyTableColumns } from 'utils/constants';
import { getClientLabel, getCompany, getImageFile, getStatusColor, parseSampleOtbMoment } from 'utils/helper';
import ResolverImage from '../resolverImage/ResolverImage';
import ImagePreview from '../imagePreview/ImagePreview';
import { EmptyState } from '../emptyState/EmptyState';
import { Link } from 'react-router-dom';
import { MetaLabel } from '../metaLabel/MetaLabel';
import StyleInfoSections from '../styleInfoSections/StyleInfoSections';
import CaptureDetail from '../capture/CaptureDetail';
import DateDisplay, { isDateString } from 'core/components/dateDisplay/DateDisplay';
// import StyleAssetViewer from "../styleInfoPanel/StyleAssetViewer";
// import DateDisplay from "../dateDisplay/DateDisplay";

const useStyles = createStyles((theme) => ({
    // ✅ v5: removed unused `_` and `u` params; use theme.fn for light/dark
    container: {
        padding: 0,
        height: '100%',
        borderLeftWidth: 0,
        borderLeftStyle: 'solid',
        borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3], // ✅ v5: inline colorScheme check instead of u.light
        '.mantine-Accordion-content': {
            paddingBottom: 0,
        },
        '.mantine-Accordion-control': {
            borderTopWidth: 1,
            borderTopStyle: 'solid',
            borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3],
        },
        '.capture-selected > div > div:first-of-type': {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: theme.colorScheme === 'dark' ? theme.colors.brand[1] : theme.colors.gray[3],
        },
        '.info-panel': {
            borderColor: theme.colorScheme === 'dark' ? theme.colors.brand[1] : theme.colors.gray[3],
        },
    },
    badgeIndex: {
        position: 'absolute',
        left: 0,
        top: 0,
    },
    imageGradient: {
        background: theme.colorScheme === 'dark' ? `linear-gradient(to top, #25262b, transparent)` : `linear-gradient(to top, #fff, transparent)`, // ✅ v5: inline colorScheme instead of u.light
        height: 200,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 16,
    },
    barcodeSection: {
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.white,
    },
}));

const MasterDrawer = ({ item, opened, doFetch = true, globalSearch, user, aggData }) => {
    const { classes } = useStyles();
    const [activeTab, setActiveTab] = useState('info');
    const [session, setSelectedSession] = useState(null);
    const [talent, setTalent] = useState([]);
    const dispatch = useDispatch();
    const hasFetched = useRef(false);

    const [selectedAsset, setSelectedAsset] = useState(null);
    const imageModalOpen = globalSearch?.imageModalOpen ?? false;
    const [scanImage, setScanImage] = useState(null);
    const selectedItem = globalSearch?.style;
    const [loading, setLoading] = useState(false);
    logger.log(globalSearch);

    const showMetaInfo = globalSearch?.showMetaInfo ?? true;

    const toggleShowMetaInfo = () => {
        dispatch(setGlobalSearch({ ...globalSearch, showMetaInfo: !showMetaInfo }));
    };

    const imageLocHash = useRef({});



    useEffect(() => {
        logger.log(selectedItem);

        if (selectedItem && selectedItem.scanUrl) {
            getImageFile(selectedItem.scanUrl)
                .then((response) => response.blob())
                .then((blob) => {
                    const url = URL.createObjectURL(blob);
                    logger.log(blob);
                    setScanImage({ name: item.id, preview: url });
                });
        }

        const getStyleInfo = async (id) => {
            try {
                setLoading(true);
                const data = await getStyleGlobalSearch(id);
                logger.log(data);
                if (data && data.id && data.id.length) {
                    logger.log(data);
                    const { masters, sessions, seasons, assets, ...rest } = data;
                    dispatch(
                        setGlobalSearch({
                            ...globalSearch,
                            style: { ...data, masters, sessions, seasons, assets },
                        }),
                    );
                    setLoading(false);
                } else if (data && data.masters && data.masters.length) {
                    dispatch(setGlobalSearch({ ...globalSearch, style: { ...item, masters: data.masters } }));
                    setLoading(false);
                } else {
                    throw new Error('Style not found');
                }
            } catch (e) {
                setLoading(false);
                dispatch(setGlobalSearch({ ...globalSearch, style: { ...item, masters: [] } }));
            }
        };
        logger.log(item, globalSearch);
        if (item && item.styleNumber && item.styleNumber !== globalSearch?.style?.styleNumber) {
            getStyleInfo(item.styleNumber);
        }
    }, [item, opened, globalSearch?.style]);

    const zoomImage = (data) => {
        logger.log(data);
        setSelectedAsset(data);
        dispatch(setGlobalSearch({ ...globalSearch, imageModalOpen: true }));
    };

    const columns = CompanyTableColumns[getCompany(aggData)?.code]?.seasonMasters || [];

    logger.log('item', item, columns, selectedItem);

    const onCaptureChange = (type, data, items) => {};

    return (
        <Box className={`${classes.container} info-panel`}>
            <div style={{ width: '100%', height: 'calc(100% - 70px)' }}>
                <ScrollArea style={{ height: '100%' }}>
                    {globalSearch?.style ? (
                        <Card pt='sm' style={{ background: 'none' }} radius={0}>
                            <Card.Section style={{ position: 'relative', minHeight: loading ? 300 : 0 }}>
                                {selectedItem?.assets && selectedItem?.assets.length && !loading ? (
                                    <ResolverImage
                                        className={classes.image}
                                        fit='cover'
                                        src={selectedItem?.assets && selectedItem?.assets.length && !loading ? selectedItem?.assets[0]?.preview : ''}
                                        alt={selectedItem?.name}
                                        height={300}
                                    />
                                ) : (
                                    <>{loading ? <Skeleton height={300} width='100%' /> : null}</>
                                )}

                                {selectedItem?.assets && selectedItem?.assets.length ? <div className={classes.imageGradient}></div> : null}
                            </Card.Section>

                            {selectedItem?.assets && selectedItem?.assets.length ? (
                                <>
                                    
                                        <Group
                                            noWrap // ✅ v5: noWrap instead of wrap={false}
                                            position='apart' // ✅ v5: position="apart" instead of justify="space-between"
                                            mt='lg'
                                            align='flex-start'>
                                            {loading ? (
                                                <Stack spacing='xs'>
                                                    {' '}
                                                    <Skeleton height={48} width={250} />
                                                </Stack>
                                            ) : (
                                              <Anchor component={Link} className='router-link' to={`warehouse/styles/${selectedItem.styleNumber}`} onClick={() => closeAllModals()}>
                                                <Title
                                                    className='main-content-heading'
                                                    order={5}
                                                    w={200}
                                                    display={'inline-block'}
                                                    style={{ wordWrap: 'break-word', textDecoration: 'inherit' }}>
                                                    {selectedItem?.name}
                                                </Title>
                                                </Anchor>
                                            )}
                                            {selectedItem.status && !loading ? (
                                                <Badge variant='light' color={getStatusColor(selectedItem.status)} sx={{ flexShrink: 0, 'span:': { textDecoration: 'none' } }}>
                                                    {selectedItem.status}
                                                </Badge>
                                            ) : null}
                                            {selectedItem.distributionDate && selectedItem.distributionDate.length ? (
                                                <Group spacing='xs'>
                                                    {' '}
                                                    <Anchor component={Link} className='router-link' to={`warehouse/styles/${selectedItem.styleNumber}`} onClick={() => closeAllModals()}>
                                                    <Tooltip color='dark' label='Navigate to Style Distribution'>
                                                        <ActionIcon variant='default'>
                                                            <IconArrowUpRight size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />
                                                        </ActionIcon>
                                                    </Tooltip>
                                                    </Anchor>
                                                </Group>
                                            ) : null}
                                        </Group>
                                    {/* </Link> */}

                                    <Box>
                                        <Group my='md'>
                                            <MetaLabel>Style Number</MetaLabel>
                                            <div>
                                                <Text size='sm'>
                                                    <Anchor component={Link} to={`warehouse/styles/${selectedItem.styleNumber}`} onClick={() => closeAllModals()}>
                                                        {selectedItem?.styleNumber}
                                                    </Anchor>
                                                </Text>
                                            </div>
                                        </Group>
                                        <Group my='md'>
                                            <MetaLabel>Department</MetaLabel>
                                            <div>
                                                <Text size='sm'>{selectedItem.dept}</Text>
                                            </div>
                                        </Group>
                                        <Group my='md'>
                                            <MetaLabel>{getClientLabel(getCompany(aggData), 'otbDate')}</MetaLabel>
                                            <div>
                                                <Text
                                                    size='sm'
                                                    color={
                                                        // ✅ v5: color instead of c
                                                        parseSampleOtbMoment(selectedItem.otbDate) ? 'inherit' : 'dimmed'
                                                    }>
                                                    {parseSampleOtbMoment(selectedItem.otbDate) ? <DateDisplay value={parseSampleOtbMoment(selectedItem.otbDate)} /> : '-'}
                                                </Text>
                                            </div>
                                        </Group>
                                        <Group my='md'>
                                            <MetaLabel>Shoot Date</MetaLabel>
                                            <div>
                                                <Text
                                                    size='sm'
                                                    color={
                                                        // ✅ v5: color instead of c
                                                        isDateString(selectedItem.shootDate) ? 'inherit' : 'dimmed'
                                                    }>
                                                    {isDateString(selectedItem.shootDate) ? <DateDisplay value={selectedItem.shootDate} /> : '-'}
                                                </Text>
                                            </div>
                                        </Group>
                                        <Group my='md'>
                                            <MetaLabel>Distribution Date</MetaLabel>
                                            <div>
                                                <Text
                                                    size='sm'
                                                    color={
                                                        // ✅ v5: color instead of c
                                                        isDateString(selectedItem.distributionDate) ? 'inherit' : 'dimmed'
                                                    }>
                                                    {isDateString(selectedItem.distributionDate) ? <DateDisplay value={selectedItem.distributionDate} /> : '-'}
                                                </Text>
                                            </div>
                                        </Group>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    {!loading ? (
                                        <Alert color='orange' title='Record Not Found' mt={5}>
                                            <Text size='sm' opacity={0.7}>
                                                No Distribution events for this keycode
                                            </Text>
                                        </Alert>
                                    ) : null}
                                </>
                            )}

                            <StyleInfoSections selectedItem={selectedItem} user={user} loading={loading} storageKey='master-drawer' aggData={aggData} />

                            {selectedItem?.assets && selectedItem?.assets.length ? <Divider /> : null}

                            {selectedItem?.assets && selectedItem?.assets.length ? (
                                <Box mt='md'>
                                    <Group mb='lg'>
                                        <Title className='main-content-heading' order={6}>
                                            Assets
                                        </Title>
                                        {selectedItem?.assets?.length && !loading ? <Badge>{selectedItem?.assets?.length}</Badge> : null}
                                    </Group>
                                    <Group
                                        spacing='md' // ✅ v5: spacing instead of gap
                                        style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'start' }} // ✅ v5: wrap and justify moved to style; no wrap/justify props on Group in v5
                                    >
                                        {loading
                                            ? [...Array(3)].map((_, idx) => <Skeleton key={`skeleton-${idx}`} height={80} width={80} radius='sm' />)
                                            : selectedItem?.assets?.map((val, idx) => (
                                                  <div
                                                      key={idx}
                                                      style={{
                                                          height: '100%',
                                                          width: 80,
                                                          position: 'relative',
                                                          borderRadius: 0,
                                                          overflow: 'hidden',
                                                      }}>
                                                      {val ? <ImagePreview file={{ url: val?.thumb }} onClick={() => zoomImage(val)} height={100} width={'auto'} /> : <div></div>}
                                                  </div>
                                              ))}
                                    </Group>

                                    {!selectedItem || (selectedItem && selectedItem.assets?.length === 0) ? <EmptyState caption='There are no assets' style={{ height: 200 }} /> : null}
                                </Box>
                            ) : null}
                        </Card>
                    ) : (
                        <Center sx={{ height: '100%', minHeight: 400 }}>
                            {' '}
                            {/* ✅ v5: sx still valid in v5 */}
                            <div style={{ textAlign: 'center' }}></div>
                        </Center>
                    )}
                </ScrollArea>
            </div>

            <Modal
                opened={imageModalOpen}
                padding={0}
                sx={(theme) => ({
                    '.mantine-Modal-header': {
                        paddingLeft: theme.spacing.md,
                        paddingRight: theme.spacing.md,
                        paddingTop: theme.spacing.md,
                    },
                })}
                trapFocus={true}
                closeOnEscape={false}
                id='captureModal'
                withCloseButton={true}
                fullScreen
                withinPortal={true}
                title={selectedItem ? selectedItem.name : ''}
                zIndex={1000}
                onClose={() => dispatch(setGlobalSearch({ ...globalSearch, imageModalOpen: false }))}
                styles={{
                    modal: { padding: 0, height: '100vh' },
                }}>
                <Group
                    style={{ height: 'calc(100vh - 0px)', width: '100%',width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: 0 }}
                    sx={(theme) => ({ borderTop: theme.colorScheme === 'dark' ? `1px solid ${theme.colors.dark[4]}` : `1px solid ${theme.colors.gray[3]}` })}
                    noWrap>
                    <Box
                        sx={{
                          flex: 1,
        minHeight: 0,   
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignSelf: 'stretch',
                            flexDirection: 'column',
                            '& > div': { width: '100%', height: '100%' },
                            // ':root & > div': { width: '100%', height: '100%' },
                        }}>
                        {selectedAsset ? (
                            <CaptureDetail
                                scaleToFit={true}
                                showSettings={false}
                                resoloveImage={false}
                                image={{ ...selectedAsset, name: selectedItem.styleNumber }}
                                src={selectedAsset.preview}
                                onImageEvent={() => logger.log('On image event')}
                                onCaptureChange={onCaptureChange}
                            />
                        ) : null}
                    </Box>
                    {/* <Box sx={{ flexShrink: 0, width: '100%' }}>

                    <BottomTray
                                captures={selectedItem && selectedItem.assets ? selectedItem.assets.map((val) => ({ ...val, previewMid: val.preview , previewLo: val.preview })) : []}
                                onImageEvent={() => logger.log('On image event')}
                                selectedItems={[]}
                                comparisonItems={[]}
                                selectedCompareFrame={0}
                                imageLocHash={imageLocHash}
                                onCaptureChange={onCaptureChange}
                                showComapirsonSelection={false}
                                isSearching={false}
                                searchCursor={null}
                                loadNextPage={() => logger.log('Load next page')}
                                showLoading={false}
                                showSettings={false}
                                panelHeight={200}
                            />
                    </Box> */}
                </Group>
                {/* <StyleAssetViewer
          user={user}
          style={selectedItem}
          index={selectedItem?.assets?.findIndex(
            (val) => val.assignedSequence === selectedAsset?.assignedSequence
          )}
          onClose={() =>
            dispatch(setGlobalSearch({ ...globalSearch, imageModalOpen: false }))
          }
        /> */}
            </Modal>
        </Box>
    );
};

export default MasterDrawer;
